<template>
<div>
    <v-row dense>
        <v-col cols="12" sm="5" lg="3" class="text-sm-left">
            <label class="font-weight-bold">{{ label }}</label>
        </v-col>
        <v-col cols="12" sm="7" lg="9">
            <slot/>
        </v-col>
    </v-row>
    <v-divider v-if="line" class="my-3"/>
</div>

</template>

<script>
export default {
  name: 'RowLine',
  props: {
    label: {
      type: String,
      required: true
    },
    line: {
      type: Boolean,
      default: true
    }
  }
}
</script>
